(() => {
  const money = (cents) => {
    const currency = window.STOA?.currency || 'CLP';
    const locale = window.STOA?.locale || 'es-CL';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: currency === 'CLP' ? 0 : 2
    }).format((Number(cents) || 0) / 100);
  };

  class StoaProduct extends HTMLElement {
    connectedCallback() {
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.dataNode = this.querySelector('[data-product-variants]');
      if (!this.variantSelect || !this.dataNode) return;
      try {
        this.variants = JSON.parse(this.dataNode.textContent);
      } catch (error) {
        console.warn('STOA: no fue posible leer las variantes.', error);
        return;
      }
      this.variantSelect.addEventListener('change', () => this.onVariantChange());
    }

    onVariantChange() {
      const variant = this.variants.find((item) => String(item.id) === this.variantSelect.value);
      if (!variant) return;
      const form = this.querySelector('form[action*="/cart/add"]');
      const idInput = form?.querySelector('[name="id"]');
      if (idInput) idInput.value = variant.id;

      const price = this.querySelector('[data-product-price]');
      const compare = this.querySelector('[data-product-compare]');
      const availability = this.querySelector('[data-product-availability]');
      const submit = this.querySelector('[data-product-submit]');
      const submitText = submit?.querySelector('[data-submit-text]');

      if (price) price.textContent = money(variant.price);
      if (compare) {
        const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.hidden = !showCompare;
        compare.textContent = showCompare ? money(variant.compare_at_price) : '';
      }
      if (availability) {
        availability.textContent = variant.available ? availability.dataset.inStock : availability.dataset.outStock;
        availability.dataset.available = variant.available ? 'true' : 'false';
      }
      if (submit) submit.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? submitText.dataset.add : submitText.dataset.sold;

      if (variant.featured_image?.src) {
        const mainImage = this.querySelector('[data-product-main-image]') || this.querySelector('.stoa-product__media img');
        if (mainImage) {
          mainImage.src = variant.featured_image.src;
          mainImage.alt = variant.featured_image.alt || '';
        }
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  if (!customElements.get('stoa-product')) {
    customElements.define('stoa-product', StoaProduct);
  }
})();
